module.exports = __webpack_public_path__ + "static/media/icon_calendar.1062d89a.svg";